import React from 'react'

// Styles
import styles from '../styles/Modal.scss'

// Utilities
import { useContext } from 'react'

// Consumer
import { ModalContext } from '../context'

const Modal: React.FC = () => {

  const { content, actions } = useContext(ModalContext)
  if(!content) return null

  const handleCloseClick = () => {
    actions.closeModal()
  }

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        {content}
        <span 
          className={styles.modalClose} 
          onClick={handleCloseClick}
        >
          Close
        </span>
      </div>
    </div>
  )

}

export default Modal